function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.11111 9.29118L6 11.0026L2.88889 9.29118V7.48296L2 7V9.79956L6 12L10 9.79956V7L9.11111 7.48296V9.29118Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6 0L0 3.46293V4.28981L6 8L11.1429 4.81986V7.45439H12V3.46293L6 0ZM10.2857 4.25848L9.42857 4.7885L6 6.90878L2.57143 4.7885L1.71429 4.25848L1.12021 3.8911L6 1.0747L10.8798 3.8911L10.2857 4.25848Z"
});

var SvgEducation = function SvgEducation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "#DB6939",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEducation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/education.7ae5f1a3.svg";
export { ForwardRef as ReactComponent };